import React, { useState, useEffect } from "react";
import { Modal, List, notification, Spin, Select, Row, Col } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import http from "../../../../helpers/http";
import { DragHandle } from "../../../../components/DragHandle";
import urldata from "../../../../urldata";

const { Option } = Select;

const Ordering = ({ isOpen, onClose }) => {
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState();
  const [datalist, setDatalist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchBrands();
    }
  }, [isOpen]);

  useEffect(() => {
    if (brands.length > 0) {
      setSelectedBrand(brands[0]._id);
    }
  }, [brands]);

  useEffect(() => {
    if (selectedBrand) {
      fetchCategoriesByBrand(selectedBrand);
    } else {
      setDatalist([]);
    }
  }, [selectedBrand]);

  const fetchBrands = async () => {
    setFetching(true);
    try {
      const { data } = await http.get(urldata + "admin/products/brands");
      setBrands(data || []);
    } catch (e) {
      setBrands([]);
    }
    setFetching(false);
  };

  const fetchCategoriesByBrand = async (brandId) => {
    setFetching(true);
    try {
      const { data } = await http.get(
        `${urldata}admin/products/categories/byBrand/${brandId}`
      );
      setDatalist(data || []);
    } catch (e) {
      setDatalist([]);
    }
    setFetching(false);
  };

  const handleOrder = async (updatedData) => {
    setLoading(true);
    try {
      const payload = {
        categories: updatedData.map((item, idx) => ({
          _id: item._id,
          sort_order: idx,
        })),
      };
      const { data } = await http.put(
        urldata + "admin/products/categories/sort",
        payload
      );
      if (data) {
        notification["success"]({
          message: `Product Categories Sorting Updated Successfully`,
        });
        onClose();
      }
    } catch (e) {
      notification["error"]({ message: "Failed to update sorting" });
    }
    setLoading(false);
  };

  return (
    <Modal
      title="Product Categories Ordering"
      visible={isOpen}
      onOk={() => handleOrder(datalist)}
      okText="Update"
      confirmLoading={loading}
      onCancel={onClose}
      width={500}
    >
      <Row gutter={12} style={{ marginBottom: 16 }}>
        <Col span={24}>
          <Select
            placeholder="Select Brand"
            value={selectedBrand}
            onChange={setSelectedBrand}
            style={{ width: "100%" }}
          >
            {brands &&
              brands.map((brand) => (
                <Option key={brand._id} value={brand._id}>
                  {brand.name}
                </Option>
              ))}
          </Select>
        </Col>
      </Row>
      {fetching ? (
        <Spin style={{ width: "100%" }} />
      ) : (
        <DragDropContext
          onDragEnd={(param) => {
            const srcI = param.source.index;
            const destI = param.destination?.index;
            if (destI !== undefined) {
              let temparray = [...datalist];
              temparray.splice(destI, 0, temparray.splice(srcI, 1)[0]);
              setDatalist(temparray);
            }
          }}
        >
          <Droppable droppableId="droppable-1">
            {(provided, _) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={{ maxHeight: 400, overflow: "auto" }}
              >
                <List
                  bordered
                  dataSource={datalist}
                  renderItem={(item, i) => (
                    <Draggable key={item._id} draggableId={item._id} index={i}>
                      {(provided, snapshot) => (
                        <div ref={provided.innerRef}>
                          <List.Item
                            {...provided.draggableProps}
                            style={{
                              ...provided.draggableProps.style,
                              boxShadow: snapshot.isDragging
                                ? "0 0 .4rem #666"
                                : "none",
                            }}
                          >
                            <span>{item.name}</span>
                            <DragHandle {...provided.dragHandleProps} />
                          </List.Item>
                        </div>
                      )}
                    </Draggable>
                  )}
                />
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </Modal>
  );
};

export default Ordering;
